import { render, staticRenderFns } from "./SgInfo.vue?vue&type=template&id=fda5b3d2&"
import script from "./SgInfo.vue?vue&type=script&lang=js&"
export * from "./SgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports